module.exports = __webpack_public_path__ + "static/media/164419_522648331108293_1374810965_n.ea5d52b8.jpg";